// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftMessageDescription__draft-header-aca907 {
  padding-inline-end: 4px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--danger-40);
}

.DraftMessageDescription__text-a7bf5a {
  white-space: nowrap;
  display: inline;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupDescription/DraftMessageDescription/DraftMessageDescription.style.m.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,4BAAA;EACA,4CAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,4CAAA;EACA,kCAAA;AACF","sourcesContent":[".draft-header {\n  padding-inline-end: 4px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--danger-40);\n}\n\n.text {\n  white-space: nowrap;\n  display: inline;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draft-header": `DraftMessageDescription__draft-header-aca907`,
	"draftHeader": `DraftMessageDescription__draft-header-aca907`,
	"text": `DraftMessageDescription__text-a7bf5a`
};
module.exports = ___CSS_LOADER_EXPORT___;
